import { BinHistoryDataInterface } from "../../../../redux/interfaces/general.interface";
import { useAppDispatch } from "../../../../redux/hooks";
import {
  fetchPrintBinA4,
  fetchPrintBinZebra,
} from "../../../../redux/api/expedition.api";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

function BinHistoryActionButtons({
  itemId,
  crudData,
}: {
  itemId: string;
  crudData: BinHistoryDataInterface;
}) {
  const dispatch = useAppDispatch();

  const handlePrintBinA4 = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinA4({
          idBin: itemId,
        }),
      );
    }
  };

  const handlePrintBinZebra = () => {
    if (itemId) {
      dispatch(
        fetchPrintBinZebra({
          idBin: itemId,
        }),
      );
    }
  };

  return (
    <ActionMenu
      minItemsForMenu={2}
      title={`BIN ${crudData.sn_bin}`}
      ariaLabel={`Actiuni pentru BIN ${crudData.sn_bin}`}
      items={[
        {
          id: "print-a4",
          label: "Print A4",
          icon: "PRINT_A4",
          kind: "print",
          tooltip: "Descarca eticheta BIN in format PDF A4.",
          onClick: handlePrintBinA4,
        },
        {
          id: "print-zebra",
          label: "Print Zebra",
          icon: "PRINT_ZEBRA",
          kind: "print",
          tooltip: "Tipareste eticheta BIN la imprimanta Zebra.",
          onClick: handlePrintBinZebra,
        },
      ]}
    />
  );
}

export default BinHistoryActionButtons;
